export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Mío',
  frontPageProvideTitle: 'Ofrezco',
  frontPagePersonalCenterTitle: 'Perfil',
  login: 'Iniciar sesión',
  home_chatWithOctopie: 'Entendiendo tus ideas',
  home_chatNeedUnderstood: 'Tus ideas fueron entendidas',
  home_draftBannerTitle: 'Termina tu mensaje',
  home_draftBannerSubtitle: 'La IA ya tiene tu mensaje listo — toca para continuar',
  home_tabHome: 'Inicio',

  // App.vue
  appRequirementTitle: 'Valoramos cada sugerencia y comentario',
  appRequirementBtn: 'Enviar',
  appSubmitSuccess: 'Enviado con éxito, gracias por tus comentarios',
  appFeedbackLink: 'Comentarios/Sugerencias',
  mobile_banner_text: 'Para la mejor experiencia, usa nuestra app',
  mobile_banner_btn: 'Obtener la app',

  // Common
  loading: 'Cargando...',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  save: 'Guardar',
  delete: 'Eliminar',
  edit: 'Editar',
  add: 'Agregar',
  search: 'Buscar',
  refresh: 'Actualizar',
  change_batch: 'Barajar',
  back: 'Volver',
  submit: 'Enviar',
  close: 'Cerrar',
  ok: 'OK',
  yes: 'Sí',
  no: 'No',
  send: 'Enviar',
  block: 'Bloquear',
  more: 'Más',
  logout: 'Cerrar sesión',
  settings: 'Ajustes',
  view_guide: 'Ver guía',
  feedback: 'Comentarios',
  feedback_title: 'Comentarios',
  feedback_new: 'Nuevo comentario',
  feedback_empty: 'Aún no hay comentarios',
  feedback_hint: 'Cuéntanos qué piensas...',
  feedback_submit: 'Enviar',
  feedback_submit_success: 'Comentario enviado con éxito',
  feedback_submit_failed: 'Error al enviar el comentario',
  feedback_reply_label: 'Respuesta de la plataforma',
  register: 'Registrarse',
  name: 'Nombre',
  email: 'Correo electrónico',
  mobile: 'Teléfono móvil',
  password: 'Contraseña',
  verification_code: 'Código de verificación',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'Todos los derechos reservados.',
  footerVersion: 'Versión {version}',
  copy: 'Copiar',
  regenerate: 'Regenerar',
  generate: 'Generar',
  contact_now: 'Chatear',
  yours: 'tú',
  xiaoyao_analysis: 'Análisis de IA',
  brand_name: 'OctoSay',
  anonymous: 'Anónimo',
  no_summary: 'Sin resumen',
  file: 'Archivo',
  discover: 'Descubrir',
  discover_title: 'Descubrir',
  discover_hotChannels: 'Canales populares',
  discover_allChannels: 'Todos',
  discover_searchChannel: 'Buscar canal',
  discover_noChannels: 'No se encontraron canales',

  // Messages
  operationSuccess: 'Operación exitosa',
  operationFailed: 'La operación falló',
  networkError: 'Error de red, inténtalo más tarde',
  dataLoadingFailed: 'Error al cargar los datos',
  noData: 'Sin datos',
  deleteConfirm: '¿Seguro que quieres eliminar?',
  saveConfirm: '¿Seguro que quieres guardar?',

  // Form Validation
  required: 'Este campo es obligatorio',
  emailInvalid: 'Ingresa una dirección de correo válida',
  phoneInvalid: 'Ingresa un número de teléfono válido',
  passwordTooShort: 'La contraseña debe tener al menos {min} caracteres',
  passwordMismatch: 'Las contraseñas no coinciden',

  // Time
  today: 'Hoy',
  yesterday: 'Ayer',
  justNow: 'Justo ahora',
  minutesAgo: 'hace {min} minutos',
  hoursAgo: 'hace {hour} horas',
  daysAgo: 'hace {day} días',

  // Footer
  about: 'Acerca de',
  footerPrivacy: 'Política de privacidad',
  footerTerms: 'Términos del servicio',
  footerSupport: 'Soporte',

  // Register
  registerAgeConfirm: 'Confirmo que tengo al menos 13 años',
  registerAgeConfirm18: 'Confirmo que tengo al menos 18 años',
  registerTermsPrefix: 'He leído y acepto los ',
  registerTermsAnd: ' y ',
  registerAgeError: 'Confirma tu edad',
  registerTermsError: 'Acepta los términos y la política de privacidad',

  // Chat
  chatPrivacyTip: 'Escribe tu mensaje en el grupo y la IA primero conversará contigo para aclarar. Al confirmar, tu mensaje y el resumen de la IA se publican juntos y AI sigue buscando matches.',
  aiChat_quickSuggestions: 'Prueba diciendo',
  aiChat_welcome: "¡Hola! Cuéntame qué buscas.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Detalles entendidos — publica para encontrar tu match',
  aiChat_readyToPostHint: 'Sigue conversando para agregar detalles o actualizar el resumen cuando quieras',
  aiChat_progressStep1: 'Entender detalles',
  aiChat_progressStep1Done: 'Detalles entendidos',
  aiChat_progressStep2: 'Resumen de IA',
  aiChat_progressStep2Desc: 'AI crea un resumen para el matching',
  aiChat_progressStep3: 'Publicar en el Grupo',
  aiChat_progressStep3Desc: 'Publica y encuentra tu match',
  aiChat_publishExtraHint: 'Ingresa tu mensaje para el grupo',
  aiChat_publishMsgRequired: 'Obligatorio',
  aiChat_publishMsgLabel: 'Tu mensaje para el grupo',
  aiChat_matchSummaryLabel: 'Resumen de IA',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'El siguiente contenido fue generado por IA y es solo de referencia.',
  aiChat_publishSuggestionHint: 'Toca para reemplazar',
  aiChat_allowDirectContact: 'Permitir contacto directo',
  aiChat_allowDirectContactDesc: 'Otros pueden contactarte directamente sin hacer match',
  channel_chat_session_publishToChannel: 'Publicar en el Grupo Octo',
  aiChat_newChat: 'Reiniciar',

  // Channels / Grupos
  home_tabChannels: 'Grupos Octo',
  channels_title: 'Grupos Octo',
  channels_myChannels: 'Grupos a los que perteneces',
  channels_discover: 'Descubrir',
  channels_noChannels: 'Aún no hay grupos',
  channels_noMyGroupsTitle: 'Aún no te has unido a ningún grupo',
  channels_noMyGroupsSubtitle: 'Busca un grupo para unirte y empieza a conectar',
  channels_searchGroupsBtn: 'Buscar grupos',
  channels_loginPrompt: 'Inicia sesión para ver los grupos',
  channels_create: 'Crear Grupo Octo',
  channels_search: 'Buscar Grupos Octo',
  channels_searchMyGroups: 'Buscar mis Grupos Octo',
  channels_searchHint: 'Buscar',
  channels_searchHintChats: 'Buscar chats...',
  channels_searchHintGroups: 'Buscar grupos...',
  channels_searchHintMy: 'Buscar grupos a los que perteneces...',
  channels_joinByCode: 'Unirse con código',
  channels_joinByCodeTitle: 'Unirse al Grupo Octo con código',
  channels_joinByCodeHint: 'Ingresa el código del Grupo Octo',
  channels_joinByCodeConfirm: 'Unirse',
  channels_joinByCodeNotFound: 'Grupo no encontrado',
  channels_createNewGroup: 'Crear un nuevo Grupo Octo',
  channels_noResults: 'No se encontraron grupos',
  channel_detail_join: 'Unirse',
  channel_detail_leave: 'Salir',
  channel_detail_members: 'miembros',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} se unió al hub',
  channelJoinMsg_twoJoined: '{name1} y {name2} se unieron al hub',
  channelJoinMsg_multiJoined: '{name1}, {name2} y {n} más se unieron al hub',
  channelJoinMsg_oneAndMoreJoined: '{name} y {n} más se unieron al hub',
  channelJoinMsg_membersJoined: '{n} miembros se unieron al hub',

  // Feed
  channels_feed: 'Chats',
  channels_groups: 'Grupos',
  feed_related: 'Relacionado',
  feed_recommend: 'Recomendado',
  feed_empty: 'Aún no hay contenido, explora los grupos populares',
  feed_goToGroup: 'Ver en el grupo',
  feed_joinGroupAndSendMsg: 'Únete a un grupo y envía un mensaje',
  channel_detail_channelCode: 'Código del Grupo Octo',
  channel_detail_invitePhrase: 'Te invitamos a "{name}"\nCódigo de invitación {code} — abre la app para unirte automáticamente · La IA aclara primero y te encuentra a las personas adecuadas',
  channel_detail_post: 'Publicar en el Grupo',
  channel_detail_aiHint: "Escribe tu mensaje en el grupo y AI aclarará primero los detalles",
  channel_input_hint: 'Di algo...',
  channel_leave_confirm_message: '¿Seguro que quieres salir de este grupo? Ya no recibirás mensajes del grupo.',
  channel_invite_notFound: 'Grupo no encontrado o el enlace expiró',
  channel_invite_joinBtn: 'Descargar la app de OctoSay',
  channel_invite_hint: 'Descarga la app, luego escanea este código QR o busca el nombre del grupo para unirte',
  channel_invite_globalHintTitle: 'Estás por descargar la versión Global',
  channel_invite_globalHintIOS: 'Esta app puede no estar disponible en el App Store de China. Cambia a una región de Apple Store fuera de China y busca OctoSay, o descarga el APK directamente abajo.',
  channel_invite_globalHintAndroid: 'Puede que Google Play no esté accesible en tu región. Recomendamos descargar el APK directamente, o probar Google Play.',
  channel_invite_globalHintDefault: 'La app puede no estar disponible en la tienda local. Recomendamos descargar el APK directamente, o probar el App Store.',
  channel_invite_globalBtnAppStore: 'Ir al App Store',
  channel_invite_globalBtnGooglePlay: 'Ir a Google Play',
  channel_invite_globalBtnAPK: 'Descargar APK directamente',
  channel_invite_defaultDesc: 'Únete a {name} en OctoSay',
  share: 'Compartir',
  share_channel: 'Compartir grupo',
  share_channel_link: 'Compartir enlace',
  channel_detail_inviteCode: 'Código de invitación',
  channel_detail_copyLink: 'Copiar enlace',
  share_session_title: 'Una publicación en OctoSay',
  share_match_title: 'Un match en OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'Mira la publicación de {userName} en OctoSay',
  session_share_notFound: 'Publicación no encontrada o el enlace expiró',
  session_share_fromChannel: 'Desde Grupo Octo',
  session_share_downloadBtn: 'Descargar la app de OctoSay',
  session_share_hint: 'Descarga la app para ver la publicación completa y unirte al grupo',
  session_share_openInApp: 'Abrir en la app',
  toast_link_copied: 'Enlace copiado',
  toast_no_share_data: 'Nada que compartir',
  channels_joinByQR: 'Código QR',
  channels_joinByQRWebHint: 'La web no admite escanear códigos QR. Ingresa el código del grupo para unirte.',
  channels_joinByQRTitle: 'Unirse con código QR',
  channel_detail_qrCode: 'Código QR',
  channel_detail_qrCodeSave: 'Guardar imagen',
  channel_detail_qrCodeSaveHint: 'Haz clic derecho en la imagen para guardar',
  channel_detail_qrCodeSaved: 'Guardado en el álbum',
  channel_detail_qrCodeSaveFailed: 'Error al guardar, inténtalo de nuevo',
  channel_detail_locateFailed: 'Error al localizar el mensaje',
  channel_detail_locateError: 'Error al localizar el mensaje',
  channel_detail_myMessages: 'Mis mensajes',
  channel_detail_searchMessages: 'Buscar mensajes',
  channel_detail_aiChat: 'Chat de AI',
  channel_detail_matchHistory: 'Historial de matches',
  channel_create_title: 'Crear Grupo Octo',
  channel_create_name: 'Nombre del Grupo Octo',
  channel_create_description: 'Descripción',
  channel_create_submit: 'Crear',
  channelCreate_aiAssist: 'AI te ayudará a crear un grupo adecuado',
  channelCreate_nameHint: 'Ingresa un nombre para tu grupo',
  channelCreate_descHint: 'Describe de qué trata tu grupo',
  channelCreate_creating: 'Creando...',
  channelCreate_created: '¡Grupo creado!',
  channelCreate_failed: 'Error al crear el grupo',
  channelCreate_welcomeMsg: "¡Hola! Estoy aquí para ayudarte a crear un grupo. Cuéntame qué tipo de grupo quieres — su tema o propósito — y lo convertiré en un nombre e introducción de grupo, y además generaré un avatar.",
  channelCreate_aiHint: 'Escribe el tema de tu grupo...',
  channelCreate_clarifyingProgress: 'Organizando el tema de tu grupo...',
  channelCreate_readyToCreate: 'Listo para crear el Grupo Octo',
  channelCreate_step1: 'Describir el tema',
  channelCreate_step1Done: 'Idea aclarada',
  channelCreate_step2: 'Crear Grupo Octo',
  channelCreate_confirmBtn: 'Confirmar creación',
  channelCreate_publicNotice: 'Los grupos son espacios públicos para que personas con intereses en común se reúnan y conecten. La plataforma puede gestionar, actualizar o fusionar grupos según sea necesario. Comparte este grupo con quienes puedan estar interesados.',
  channelCreate_similarGroupsTitle: 'Grupos Octo similares encontrados',
  channelCreate_similarGroupsDesc: 'Estos grupos podrían encajar con lo que buscas',
  channelCreate_exactMatchHint: '¡Ya existe un grupo con este nombre exacto!',
  channelCreate_joinHint: 'Estos grupos existentes podrían encajar bien',
  channelCreate_joinExisting: 'Unirse a un Grupo Octo existente',
  channelCreate_stillCreate: 'Aún crear un nuevo Grupo Octo',
  channel_chat_session_comments: 'Comentarios',
  channel_chat_session_commentHint: 'Escribe un comentario...',
  channel_chat_session_sendComment: 'Comentar',
  channel_chat_session_loadMore: 'Cargar más',
  channel_chat_session_noComments: 'Aún no hay comentarios',
  channel_chat_session_deleteComment: 'Eliminar',
  channelSearch_title: 'Buscar en el Grupo',
  channelSearch_placeholder: 'Buscar mensajes...',
  channelSearch_onlyMine: 'Solo mis publicaciones',
  channelSearch_tabAllMessages: 'Mensajes del grupo',
  channelSearch_tabMyMessages: 'Mis mensajes',
  chatMsgSearch_placeholder: 'Buscar mensajes',
  chatMsgSearch_tabMsgs: 'Mensajes',
  chatMsgSearch_tabContacts: 'Contactos',
  chatMsgSearch_emptyPrompt: 'Escribe palabras clave para buscar mensajes',
  chatMsgSearch_tooShort: 'Escribe al menos 2 caracteres para buscar',
  chatMsgSearch_contactEmptyPrompt: 'Escribe un nombre de usuario o correo para buscar contactos',
  chatMsgSearch_noContacts: 'No se encontraron contactos',
  chatMsgSearch_inChatPlaceholder: 'Buscar en este chat',
  channelHistory_title: 'Historial',
  channelHistory_myMessages: 'Mis mensajes',
  channelHistory_loadMore: 'Cargar más',
  channel_settings_push: 'Notificaciones del Grupo Octo',
  channel_settings_commentPush: 'Notificaciones de comentarios',
  channel_settings_likePush: 'Notificaciones de me gusta',
  channel_settings_receiveNotifications: 'Recibir notificaciones',
  channel_settings_directContact: 'Permitir contacto directo',
  session_published: 'Publicado',
  session_publishFailed: 'Error al publicar',
  session_setDirectContactSuccess: 'Ajuste guardado',
  session_setDirectContactFailed: 'Error al guardar el ajuste',
  session_setPrivate: 'Hacer privado',
  session_setPublic: 'Hacer público',
  session_pauseMatching: 'Pausar emparejamiento',
  session_resumeMatching: 'Reanudar emparejamiento',
  session_matchPausedToast: 'Emparejamiento pausado',
  session_matchResumedToast: 'Emparejamiento reanudado',
  match_matchingPausedTitle: 'El emparejamiento está en pausa',
  match_reasonTag: 'Motivo del match',
  match_matchingPausedHint: 'Reactiva el emparejamiento cuando quieras.',
  session_confirmSetPrivate: '¿Hacer privado este contenido? Los demás usuarios no podrán verlo.',
  session_messageIsPrivate: 'Este mensaje es privado',
  chatSessionComment_replyHint: 'Escribe un comentario...',
  chatSessionComment_reply: 'Comentar',
  chatSessionComment_count: '{n} comentario | {n} comentarios',
  chatSessionMatch_count: '{n} coincidencia | {n} coincidencias',
  chatSessionComment_replyTo: 'Responder',
  chatSessionComment_inputHint: 'Escribe un comentario...',
  chatSessionComment_send: 'Enviar',
  chatSessionComment_delete: 'Eliminar',
  chatSessionComment_deleteConfirm: '¿Seguro que quieres eliminar este comentario?',
  chatSessionComment_loadMore: 'Cargar más',
  chatSessionComment_noMore: 'No hay más comentarios',
  chatSessionComment_loginToComment: 'Inicia sesión para comentar',
  chatSessionComment_viewEarlier: 'Ver {n} respuestas anteriores',
  chatSessionLike_like: 'Me gusta',
  chatSessionLike_liked: 'Te gusta',
  chatSessionLike_count: 'me gusta',
  chatSessionBookmark_bookmark: 'Guardar',
  chatSessionBookmark_bookmarked: 'Guardado',
  chatSessionMatch_viewMatches: 'Ver matches',
  chatSessionMatch_matchHistory: 'Historial de matches',
  chatSessionMatch_noMatches: 'Aún no hay matches',
  channel_match_achievement: '{count} publicaciones con match exitoso',
  channel_match_achievement_view: 'Ver →',
  channel_matchHistory_title: 'Historial de matches del canal',
  chatSessionMatch_matchedAt: 'Match hecho el {time}',
  discover_userMsgLabel: 'El usuario dijo',
  common_loading: 'Cargando...',
  common_sending: 'Enviando...',
  common_error: 'Error',
  common_success: 'Éxito',
  common_me: 'Yo',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "La IA está aclarando tu necesidad para que cada mensaje que publiques funcione; después de publicar, seguirá buscándote matches",
  aiChat_clarifyingAlmostDone: 'Casi listo, por favor confirma',
  aiChat_clarifyingOneMore: 'Falta aproximadamente 1 pregunta más, luego puedes publicar',
  aiChat_clarifyingRemaining: 'Faltan aproximadamente {count} rondas más, casi listo',
  aiChat_clarifyingEvaluating: 'Evaluando el progreso...',
  aiChat_setPublicMatch: 'Hacer público y match',
  aiChat_needsClarifiedPublic: "Ya te entiendo. Cuando confirmes y publiques, AI seguirá buscando matches para ti.\nSiéntete libre de compartir más detalles cuando quieras.",
  aiChat_needsClarifiedPrivate: '¡Entendido! ¡Hazlo público y deja que siga buscando matches para ti!\nSiéntete libre de contarme más detalles cuando quieras.',
  aiChat_setPublicTitle: 'Hacer público',
  aiChat_setPublicMessage: 'Tu contenido será visible para otros para que OctoSay encuentre matches complementarios.\n\nInformación que se compartirá:\n• Tu nombre de usuario y foto de perfil\n• El resumen de tu contenido\n• El contenido de la conversación (visible en Descubrir)\n\nPuedes volver a hacerlo privado cuando quieras.',
  aiChat_findMatches: 'Ver resultado del match',
  aiChat_publishing: 'Publicando...',
  aiChat_matchSectionTitle: 'Tu mensaje encaja mejor en estos grupos: toca para publicar',
  aiChat_joinedBadge: 'Miembro',
  aiChat_matchSectionEmpty: 'Aún no hay grupos con buena coincidencia — puedes crear un grupo nuevo y publicar ahí',
  aiChat_suggestPublishCreateNew: 'Crear un grupo nuevo',
  aiChat_repickChannel: 'Cambiar de grupo',
  aiChat_creatingChannelTitle: 'No hay un grupo adecuado — te creamos uno',
  aiChat_creatingChannelHint: 'La IA crea un grupo para tu solicitud y luego pasas directo a publicar; suele tardar 10-30 s',
  aiChat_publishToChannelHint: 'Se publicará en "{name}"',
  aiChat_pickChannelTitle: 'Elige un grupo para publicar',
  aiChat_matchingChannelTitle: 'Buscando el grupo adecuado para ti',
  aiChat_matchingChannelHint: 'La IA busca según tu solicitud; suele tardar de unos segundos a medio minuto',
  aiChat_matchUnavailableTitle: 'Recomendaciones no disponibles',
  aiChat_matchUnavailableHint: 'Busca un grupo abajo o cierra y vuelve a abrir la publicación',
  aiChat_waitSlowHint: 'Está tardando más de lo normal, pero sigue en curso — espera un poco más o busca un grupo abajo',
  aiChat_creatingSlowHint: 'La creación va más lenta de lo normal, pero sigue en curso — después pasas directo a publicar',
  aiChat_pickChannelEmptyHint: 'No se encontraron grupos relacionados. Crea un grupo nuevo y publica tu mensaje',
  aiChat_loadMore: 'Cargar más',
  sidebar_publish: 'Publicar',
  chat_selectLocationOnMap: 'Selecciona una ubicación en el mapa',

  // App.vue new
  placeholder_email: 'Ingresa tu correo electrónico',
  placeholder_mobile: 'Ingresa tu número de teléfono',
  placeholder_password: 'Ingresa tu contraseña',
  placeholder_name: 'Ingresa tu nombre',
  random_nickname: 'Aleatorio',
  placeholder_verification_code: 'Ingresa el código de verificación',
  sending: 'Enviando...',
  registering: 'Registrando...',
  send_code: 'Enviar código',
  retry_in_seconds: 'Reintentar en {countdown}s',
  toast_enter_email: 'Ingresa tu correo electrónico',
  toast_enter_mobile: 'Ingresa tu número de teléfono',
  toast_invalid_email: 'Ingresa un formato de correo válido',
  toast_invalid_mobile: 'Ingresa un número de teléfono válido',
  toast_send_code_failed: 'Error al enviar el código de verificación',
  toast_code_sent: 'Código de verificación enviado al correo',
  toast_code_sent_sms: 'Código de verificación enviado al teléfono',
  toast_send_code_error: 'Error al enviar el código de verificación, inténtalo más tarde',
  toast_fill_all_fields: 'Completa todos los campos',
  toast_login_failed: 'Error al iniciar sesión',
  toast_login_success: 'Sesión iniciada',
  oauthOr: 'o',
  toast_oauth_login_failed: 'Falló el inicio de sesión con Google',
  toast_oauth_login_error: 'Error de inicio de sesión con Google, inténtalo de nuevo',
  toast_login_error: 'Error al iniciar sesión, inténtalo más tarde',
  toast_register_failed: 'Error al registrarse',
  toast_register_success: 'Registro exitoso',
  toast_register_error: 'Error al registrarse, inténtalo más tarde',

  // AdBanner.vue
  ad: 'Anuncio',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'Antes de conectar',
  contactAd_gateSubtitle: 'Esta breve pausa mantiene OctoSay gratis — ¡gracias por tu apoyo!',
  contactAd_waitBtn: 'Continuar en {sec}s',
  contactAd_continueBtn: 'Continuar al chat',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Chat',

  // AiMatch.vue
  ai_welcome_msg: 'Hola, soy AI. Cuéntame qué tienes en mente — un compañero, un socio, un intercambio de habilidades o CUALQUIER cosa.',
  default_username: 'Usuario',

  // AvatarCropDialog.vue
  crop_hint: 'Pellizca para hacer zoom, arrastra para ajustar',
  toast_crop_failed: 'Error al recortar la imagen',

  // ChatBox.vue
  loading_match_info: 'Cargando info del match...',
  view_match_details: 'Ver detalles del match',
  step_clarify_needs: 'Aclarar',
  step_ai_matching: 'Publicar en el Grupo',
  step_connect: 'Match de IA',
  make_private: 'Hacer privado',
  setting: 'Configurando...',
  action_photo: 'Foto',
  action_file: 'Archivo',
  action_video: 'Video',
  action_location: 'Ubicación',
  hint_get_app: 'Obtén la app para mantenerte conectado',
  match_finding_title: 'Tus matches',
  match_finding_subtitle: 'AI sigue buscando matches para ti',
  match_time_hint: 'Este proceso suele tardar 1-2 minutos',
  match_result_stats: 'Encontramos {matched} mejores matches{interested}',
  match_tap_to_connect: 'Toca para iniciar la conversación',
  match_channel_hint: 'Emparejando en el grupo <strong>#{channel}</strong>. Priorizamos matches del mismo grupo, pero puede incluir otros grupos si es necesario.',
  label_perfect_match: 'Mejor match',
  label_worth_a_look: 'Vale la pena ver',
  match_no_result_title: 'Siguiendo con tu match',
  match_no_result_desc: 'Comparte más detalles para ayudar a OctoSay a seguir encontrando los matches indicados. Instala la app para recibir notificaciones cuando alguien haga match contigo.',
  go_back: 'Volver',
  no_public_requirements: 'Aún no hay publicaciones públicas',
  channelEmpty_title: 'Todo tranquilo por aquí',
  channelEmpty_subtitle: 'Sé el primero en compartir tus ideas',
  channelEmpty_hint: "Escribe tus ideas y AI te ayudará a aclararlas y seguir emparejando, para que tu mensaje no se hunda",
  channelEmpty_action: 'Comparte tus ideas',
  stay_connected: 'Mantente conectado',
  download_app_desc: '¡Obtén la app para chatear y recibir notificaciones al instante cuando alguien te conecte!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'APK directo',
  match_history: 'Historial de matches',
  no_match_history: 'Aún no hay historial de matches',
  finding_matches: 'AI sigue buscando matches para ti - Después de publicar un mensaje en un grupo',
  discover_connect_hint: '¡Podrás chatear cuando hagas match!',
  match_initializing: 'Inicializando...',
  placeholder_login_to_chat: 'inicia sesión para contarme qué tienes en mente',
  toast_need_clear: '¡Tu idea ya está clara!',
  toast_ai_responding: 'AI está respondiendo, espera...',
  toast_uploading_image: 'Subiendo imagen, espera...',
  toast_uploading_file: 'Subiendo archivo, espera...',
  toast_max_photos: 'Máximo {max} fotos permitidas',
  toast_uploading: 'Subiendo, espera...',
  toast_file_too_large: '{name} supera el límite de 5MB',
  toast_video_too_large: '{name} supera el límite de 20MB',
  toast_video_processing: 'El video se está procesando, espera...',
  toast_upload_link_failed: 'Error al obtener el enlace de subida',
  analyzing_image: 'Analizando imagen...',
  toast_location_confirmed: 'Ubicación confirmada',
  toast_location_selected: 'Ubicación seleccionada',
  toast_enter_search: 'Ingresa el contenido a buscar',
  toast_search_failed: 'Error en la búsqueda',
  toast_no_locations: 'No se encontraron ubicaciones',
  toast_search_error: 'Error en la búsqueda, inténtalo de nuevo',
  toast_located_at: 'Ubicado en: {address}',
  toast_shared_finding: '¡Compartido! Buscando matches...',
  toast_update_failed: 'Error al actualizar',
  toast_set_private: 'Establecido como privado',
  toast_no_matches: 'No se encontraron matches',
  toast_matches_found: 'Encontramos {count} mejores matches',
  toast_start_conversation_first: 'Primero inicia una conversación',
  toast_load_history_failed: 'Error al cargar el historial de matches',
  toast_ai_timeout: 'AI tardó demasiado, inténtalo de nuevo',
  toast_message_blocked: 'Mensaje bloqueado',
  network_disconnected: 'Red desconectada',
  toast_publish_success: '¡Publicado en el grupo!',
  toast_publish_failed: 'Error al publicar en el grupo',

  // ChatMsgList.vue
  collapse_thinking: 'contraer pensamiento',
  expand_thinking: 'expandir pensamiento',
  thinking: 'pensando',
  select_date: 'Seleccionar fecha',
  selected_location: 'Ubicación seleccionada',
  msg_blocked: 'Bloqueado',
  retry: 'Reintentar',
  msg_read: 'Leído',
  msg_sent: 'Enviado',
  msg_unread: 'No leído',
  label_start_datetime: 'Fecha y hora de inicio:',
  label_end_datetime: 'Fecha y hora de fin:',
  toast_select_start_datetime: 'Selecciona una fecha y hora de inicio',
  toast_end_before_start: 'La fecha y hora de fin no puede ser anterior a la de inicio',
  report_message: 'Reportar mensaje',
  block_user: 'Bloquear usuario',
  msg_revoke: 'Retirar',
  msg_quote: 'Citar',
  msg_revoked_self: 'Retiraste un mensaje',
  msg_revoked_other: 'El otro usuario retiró un mensaje',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Mensaje retirado',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'La plataforma retiró este mensaje debido a una infracción',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Mensaje retirado',
  toast_revoke_failed: 'Error al retirar el mensaje',
  toast_load_data_failed: 'Error al cargar los datos, actualiza la página.',
  toast_file_url_missing: 'URL del archivo no encontrada',
  toast_block_success: 'Usuario bloqueado con éxito',
  toast_block_failed: 'Error al bloquear al usuario',

  // ChatSession.vue
  no_more_records: 'no hay más registros.',
  title_needs_clarified: 'Ideas aclaradas',
  title_clarifying: 'Aclarando tus ideas',
  title_public: 'Público',
  title_private: 'Privado',
  badge_clarified: 'Aclarado',
  badge_clarifying: 'Aclarando',
  badge_only_me: 'Solo yo',
  badge_expired: 'Expirado',
  title_expired: 'Expirado',
  no_chat_history: 'Sin historial de chat',

  // ContactMethods.vue
  block_status_banner: 'Has bloqueado a este usuario',
  unblock_user: 'Desbloquear usuario',
  toast_block_missing_id: 'No se puede bloquear: falta el ID de usuario',
  dialog_block_confirm: '¿Seguro que quieres bloquear a {name}? No recibirás ningún mensaje de esta persona.',
  toast_user_blocked: '{name} ha sido bloqueado',
  toast_unblock_missing_id: 'No se puede desbloquear: falta el ID de usuario',
  toast_user_unblocked: '{name} ha sido desbloqueado',

  // BlockedUsers.vue
  blocked_users: 'Usuarios bloqueados',
  blocked_users_empty: 'No hay usuarios bloqueados',
  blocked_users_empty_hint: 'Los usuarios bloqueados ya no podrán enviarte mensajes',
  blocked_users_unblock: 'Desbloquear',
  dialog_unblock_confirm: 'Después de desbloquear, podrá enviarte mensajes de nuevo.',
  toast_unblock_success: 'Desbloqueado',
  toast_unblock_failed: 'Error al desbloquear, inténtalo de nuevo',
  blocked_users_load_failed: 'Error al cargar. Toca para reintentar',
  blocked_users_blocked_at: 'Bloqueado {date}',
  blocked_users_unknown_user: 'Usuario desconocido',

  // Contacts.vue
  no_connections: 'Aún no hay mensajes',
  chat_with: 'Chatear con {name}',
  toast_load_contacts_failed: 'Error al cargar las conexiones: {msg}',
  toast_load_contacts_error: 'Error al cargar las conexiones. Actualiza e inténtalo de nuevo.',
  time_just_now: 'Justo ahora',
  time_minutes_ago: 'hace {min}m',
  time_hours_ago: 'hace {hour}h',
  time_days_ago: 'hace {day}d',

  // InteractionNotification.vue
  interaction_notification_title: 'Notificaciones',
  interaction_notification_subtitle: 'Comentarios y me gusta',
  interaction_notification_empty: 'Aún no hay notificaciones',
  interaction_notification_comment: 'comentó: {content}',
  interaction_notification_like: 'le gustó tu publicación',
  interaction_notification_reply: 'respondió: {content}',
  interaction_notification_bookmark: 'guardó tu publicación',
  toast_load_notifications_failed: 'Error al cargar las notificaciones: {msg}',
  toast_load_notifications_error: 'Error al cargar las notificaciones. Actualiza e inténtalo de nuevo.',
  mark_all_read: 'Marcar todo como leído',
  toast_mark_all_read_failed: 'Error al marcar todo como leído, inténtalo de nuevo',
  contacts_dnd: 'Silenciar notificaciones',
  dnd_enabled: 'Notificaciones silenciadas',
  dnd_disabled: 'Notificaciones activadas',
  dnd_action_enable: 'Silenciar notificaciones',
  dnd_action_disable: 'Activar notificaciones',

  // Discover.vue
  toast_load_sessions_failed: 'Error al cargar las sesiones: {msg}',
  toast_load_sessions_error: 'Error al cargar las sesiones',
  discover_noMessages: 'Aún no hay mensajes',

  // EmojiInputArea.vue
  placeholder_default: 'Comparte más detalles con AI',
  userChat_typeMessage: 'Escribe un mensaje...',
  select_emoji: 'Seleccionar emoji',
  badge_new: 'nuevo',
  channel_search_placeholder: 'Ingresa el canal',
  channel_picker_empty: 'Ingresa el canal',

  // FrontPage.vue
  tab_chat_with_ai: 'Deja que OctoSay te entienda',
  history_chats: 'Historial',
  tab_connections: 'Coincidencias',
  tab_conversations: 'Mensajes',
  tab_profile: 'Perfil',
  new_session: 'Nuevo',
  history_tab_chats: 'Mío',
  history_tab_matches: 'Coincidencias',
  channels_octosay: 'Grupos Octo',
  tab_matches: 'Coincidencias',
  tab_messages: 'Mensajes',

  // Header.vue
  slogan: 'OctoSay - La IA que te entiende y te conecta con la persona indicada',
  app_name: 'OctoSay',
  slogan_short: 'La IA que te entiende y te conecta con la persona indicada',
  slogan_ai: 'La IA que te entiende y te conecta con la persona indicada',
  get_the_app: 'Obtener la app',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'o busca OctoSay en las tiendas de apps',

  // MapLocationPicker.vue
  placeholder_search_location: 'Buscar ubicación...',
  coords_display: 'Longitud: {lng}, Latitud: {lat}',
  toast_no_geolocation: 'Tu navegador no admite geolocalización',
  toast_location_permission_denied: 'No se pudo obtener tu ubicación, revisa los permisos de ubicación',
  loading_address: 'Cargando dirección...',

  // MatchedSession.vue
  created_at: 'Creado: {time}',
  ai_match_analysis: 'Análisis de match de AI',
  error_missing_session_params: 'Faltan parámetros de sesión requeridos',
  match_private_hint: 'Esta sesión es privada. El contenido no está disponible',

  // PersonalCenter.vue
  label_name: 'Nombre:',
  placeholder_enter_name: 'Ingresa tu nombre',
  label_bio: 'Bio:',
  placeholder_enter_bio: 'Escribe algo sobre ti',
  placeholder_bio_empty: 'Di algo sobre ti',
  bio: 'Bio',
  delete_account: 'Eliminar cuenta',
  delete_warning: 'Esta acción no se puede deshacer.',
  delete_data_intro: 'Los siguientes datos se eliminarán de forma permanente:',
  delete_item_profile: 'Tu información de perfil',
  delete_item_chat: 'Historial de chat y sesiones',
  delete_item_contact: 'Información de contactos',
  delete_item_all: 'Todos los datos asociados',
  final_confirmation: 'Confirmación final',
  delete_confirm_prompt: 'Escribe "delete" para confirmar:',
  placeholder_type_delete: 'Escribe delete',
  private_token: 'Token privado',
  token_desc: 'Genera un token para acceso a la API',
  toast_not_logged_in: 'Usuario sin iniciar sesión',
  toast_name_required: 'El nombre es obligatorio',
  toast_save_success: 'Guardado con éxito',
  toast_save_failed: 'Error al guardar',
  toast_image_too_large: 'La imagen supera el límite de 5MB',
  toast_avatar_updated: 'Foto de perfil actualizada',
  toast_avatar_failed: 'Error al actualizar la foto de perfil',
  toast_upload_failed: 'Error al subir',
  toast_token_generated: 'Token generado',
  toast_token_failed: 'Error al generar el token',
  toast_copied: 'Copiado al portapapeles',
  toast_copy_failed: 'Error al copiar',
  toast_account_deleted: 'Cuenta eliminada con éxito',
  toast_delete_account_failed: 'Error al eliminar la cuenta',
  toast_logout_success: 'Sesión cerrada con éxito',
  toast_logout_failed: 'Error al cerrar sesión',
  profile_tab_messages: 'Mensajes',
  profile_tab_comments: 'Comentarios',
  profile_tab_likes: 'Me gusta',
  profile_tab_bookmarks: 'Guardados',
  profile_empty_messages: 'Aún no hay mensajes',
  profile_empty_comments: 'Aún no hay comentarios',
  profile_empty_likes: 'Aún no hay me gusta',
  profile_empty_bookmarks: 'Aún no hay guardados',
  profile_reply_to: 'Responder a {name}',
  profile_stats_posts: 'Mensajes',
  profile_stats_comments: 'Comentarios',
  profile_stats_likes: 'Me gusta recibidos',
  profile_joined: 'Se unió el {date}',

  // ReportDialog.vue
  report_message_title: 'Reportar mensaje',
  report_reason_prompt: 'Selecciona el motivo para reportar este mensaje:',
  report_spam: 'Spam',
  report_harassment: 'Acoso o intimidación',
  report_inappropriate: 'Contenido inapropiado',
  report_other: 'Otro',
  placeholder_report_desc: 'Describe el problema (opcional)',
  toast_select_reason: 'Selecciona un motivo',
  toast_report_success: 'Reporte enviado con éxito',
  toast_report_failed: 'Error al enviar el reporte',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Imagen]',
  summary_images: '[Imágenes x{count}]',
  summary_file: '[Archivo]',
  summary_files: '[Archivos x{count}]',
  summary_video: '[Video]',
  summary_videos: '[Videos x{count}]',
  summary_location: '[Ubicación]',
  summary_locations: '[Ubicaciones x{count}]',
  summary_emoji: '[Emoji]',
  summary_emojis: '[Emojis x{count}]',
  summary_voice: '[Voz]',
  summary_voices: '[Voces x{count}]',
  summary_mixed: '[Mixto]',
  summary_other: '[Otro]',

  // Voice messages
  voice: 'Voz',
  voice_recording: 'Grabando...',
  toast_voice_too_short: 'Grabación demasiado corta',
  toast_voice_failed: 'Error al enviar la voz',
  toast_mic_permission_denied: 'No se puede acceder al micrófono. Actívalo en la configuración del navegador',
  toast_recording_not_supported: 'Este navegador no admite grabación de voz',
  voice_load_failed: 'Error al cargar el mensaje de voz',

  // Expire At
  aiChat_expireLine: 'Válido hasta {date}, avísale a AI cuando quieras para actualizarlo',
  aiChat_expireExpired: 'El contenido expiró y ya no es visible para otros. Avísale a AI cuando quieras para actualizar la expiración',

  // MatchedSession.vue
  detail: 'Detalle',

  // Match notification hints
  match_new_result_hint: 'Si hay nuevos resultados de match, se te notificará. Para una mejor experiencia, instala la app y recibe notificaciones al instante.',

  // Match notification hints
  match_connection_notify_hint: '¡Match hecho y notificado! ¡Ve a saludar!',
  match_continuousMatching: 'AI sigue buscando matches para ti',
  match_continuousMatchingHint: 'Te avisaremos en cuanto se encuentren nuevos matches',
  match_continuousMatchingOthers: 'AI sigue buscando matches para esa persona',
  match_continuousMatchingOthersHint: 'Los nuevos matches aparecerán aquí a medida que se encuentren',
  match_noResultsTitleOthers: 'Siguiendo con su match',
  match_noResultsHintOthers: 'AI sigue buscando matches para esa persona. Los resultados aparecerán aquí cuando se encuentren.',
  match_newMatchFound: '¡{n} nuevos matches encontrados!',
  match_worth_exploring_hint: 'Tú decides si te acercas.',

  // Matches filter tags
  filter_all: 'Todos',
  filter_best_connection: 'Mejor match',
  filter_worth_a_look: 'Vale la pena ver',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - La IA que te entiende y te conecta con la persona indicada',
  landing_hero_title: 'Escribe en tu grupo — AI aclara primero, luego publicas y haces match.',
  landing_hero_subtitle: 'Escribe el mensaje que quieres compartir en un Grupo Octo. Antes de publicarse, AI conversará contigo para afinar los detalles. Al confirmar, tu mensaje y el resumen de la IA se publican juntos, y AI empieza a emparejar.',
  landing_download_on: 'Descárgala en',
  landing_get_it_on: 'Consíguela en',
  landing_direct_download: 'Descarga directa',
  landing_how_title: 'Cómo funciona',
  landing_step1_title: 'Escribe en el Grupo',
  landing_step1_desc: 'Escribe el mensaje que quieres compartir en el grupo. La IA primero conversará contigo para aclarar los detalles, así cada publicación es clara, útil y lista para el matching — no se pierde en el ruido.',
  landing_step2_title: 'Confirma, publica y haz match',
  landing_step2_desc: 'Al confirmar, tu mensaje original y el resumen de la IA se publican juntos en el grupo. Luego la IA sigue buscando tus mejores matches, así tu mensaje no queda enterrado ni ignorado.',
  landing_step3_title: 'Conéctate y conversa',
  landing_step3_desc: 'Cuando haya match, ambos pueden ver el historial de chat de cada uno con AI y el resumen de la IA. Con contexto compartido, romper el hielo es fácil — simplemente conversen.',
  // Comparison Section
  landing_comparison_title: '¿Por qué OctoSay?',
  landing_comparison_subtitle: 'Chat de grupo, pero AI aclara tus detalles y te empareja activamente.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'Calidad del contenido',
  landing_cmp1_other: 'Spam, anuncios y floods fuera de tema',
  landing_cmp1_octo: 'Solo tarjetas de necesidades curadas por IA',
  landing_cmp2_label: 'Encontrar personas',
  landing_cmp2_other: 'Publicar y solo esperar respuestas',
  landing_cmp2_octo: 'AI te empareja activamente',
  landing_cmp3_label: 'Nivel de ruido',
  landing_cmp3_other: 'Cientos de mensajes para desplazar',
  landing_cmp3_octo: 'Cero ruido, cada publicación importa',
  landing_cmp4_label: 'Para empezar',
  landing_cmp4_other: 'Buscar servidor, explorar canales, aprender solo',
  landing_cmp4_octo: 'Escribe en el grupo; AI aclara y empareja',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Grupos inundados de anuncios y spam',
  landing_cmp1_xhs: 'Publicaciones de marketing por todos lados, difíciles de confiar',
  landing_cmp1_facebook: 'Anuncios y clickbait inundan tu feed',
  landing_cmp1_reddit: 'Spam y publicaciones fuera de tema por todos lados',
  landing_cmp2_wechat: 'Solo con contactos e invitaciones a grupos',
  landing_cmp2_xhs: 'Buscar tú mismo y excavar entre publicaciones',
  landing_cmp2_facebook: 'Limitado a tus amigos y grupos existentes',
  landing_cmp2_reddit: 'Explorar subreddits tú mismo y esperar respuestas',
  landing_cmp3_wechat: 'Desplazando cientos de mensajes de grupo',
  landing_cmp3_xhs: 'Feed lleno de recomendaciones y anuncios',
  landing_cmp3_facebook: 'Publicaciones recomendadas y anuncios sin fin',
  landing_cmp3_reddit: 'Cientos de comentarios para desplazar',
  landing_cmp5_label: 'Quién busca',
  landing_cmp5_wechat: 'Preguntar uno por uno, esperando suerte',
  landing_cmp5_xhs: 'Publicar, esperar comentarios y filtrar tú mismo',
  landing_cmp5_facebook: 'Tienes que preguntar por los grupos',
  landing_cmp5_reddit: 'Publicar, esperar respuestas y luego filtrar',
  landing_cmp5_octo: 'La IA sigue encontrando personas para ti, automáticamente',

  landing_features_title: 'Funciones principales',
  landing_feature1_title: 'Aclarar antes de publicar',
  landing_feature1_desc: 'No hay formularios que llenar. Escribe tu mensaje en el grupo y AI conversará contigo primero para hacer las preguntas correctas y entender de verdad tus necesidades.',
  landing_feature2_title: 'Limpio, no caótico',
  landing_feature2_desc: 'Tu mensaje y el resumen de la IA se publican juntos — OctoSay curó cada publicación, así que no hay spam, ni floods fuera de tema, ni ruido que desplazar.',
  landing_feature3_title: 'Matching proactivo',
  landing_feature3_desc: 'Una vez que confirmas y tu mensaje + resumen de IA están en línea, AI escanea continuamente el grupo para encontrar personas que encajen con lo que buscas — y explica por qué.',
  landing_feature4_title: 'Comunidades por tema, cero ruido',
  landing_feature4_desc: 'Únete a grupos por tema — deportes, gaming, intercambio de idiomas, compañeros de cuarto — AI aclara tu mensaje antes de publicarlo, así cada grupo se mantiene limpio y útil.',
  landing_feature5_title: 'Privacidad protegida',
  landing_feature5_desc: 'Puedes hacer privados tus mensajes después de enviarlos, visibles solo para ti. Control total.',
  landing_feature6_title: 'Conversaciones significativas',
  landing_feature6_desc: 'Sin ruido ni distracciones — cada mensaje importa.',
  landing_usecases_title: 'Funciona para cualquier escenario',
  landing_usecases_subtitle: 'Sea lo que sea que tengas en mente, únete a un grupo por tema — AI se encarga del matching para que no tengas que desplazarte y buscar',
  landing_usecase_game: 'Compañero de juego',
  landing_usecase_language: 'Intercambio de idiomas',
  landing_usecase_skill: 'Intercambio de habilidades',
  landing_usecase_roommate: 'Buscar compañero de cuarto',
  landing_usecase_travel: 'Compañero de viaje',
  landing_usecase_sports: 'Compañero de deporte',
  landing_usecase_study: 'Compañero de estudio',
  landing_usecase_anything: '...o comparte cualquier cosa',
  landing_cta_title: '¿Listo para empezar?',
  landing_cta_desc: 'Únete a un grupo por tema, escribe lo que quieres compartir, deja que AI aclare los detalles, luego publica y haz match con las personas indicadas.',
  landing_use_now: 'Usar ahora',
  landing_groups: 'Grupos',

  // OnboardingPage.vue
  onboarding_skip: 'Omitir',
  onboarding_next: 'Siguiente',
  onboarding_getStarted: 'Comenzar',
  onboarding_step1Title: "Di lo que necesitas en el grupo",
  onboarding_step1Desc: "Sea lo que busques o quieras hacer, dilo directamente. La IA conversa contigo para aclarar los detalles y lo convierte en una necesidad clara que todos entienden.",
  onboarding_step2Title: 'Confirma, publica y haz match',
  onboarding_step2Desc: "Cuando tu mensaje se publica en el grupo, la IA sigue buscando tus mejores matches, así tu mensaje no queda enterrado ni ignorado.",
  onboarding_step3Title: 'Conéctate y conversa',
  onboarding_step3Desc: "Ambos pueden ver la conversación del otro con la IA y saber qué busca. Con contexto compartido, romper el hielo es fácil — simplemente conversen.",

  // ChannelDetail.vue
  channel_image_limit: 'Máximo 1 imagen',

  // ChannelMembers.vue
  channel_members_empty: 'Aún no hay miembros',
  channel_members_title: 'Miembros',
  channel_role_owner: 'Propietario',
  channel_role_admin: 'Administrador',
  channel_role_member: 'Miembro',

  // Settings.vue
  settings_language: 'Idioma',
  settings_language_followSystem: 'Según el sistema',

  // ChatBox.vue
  match_interested_suffix: ', {count} para revisar',

  // ChatBox.vue - Etapas del progreso de emparejamiento con IA
  match_stage_fetch_chat: 'Obteniendo conversación',
  match_stage_query_expansion: 'Ampliando consultas',
  match_stage_semantic_search: 'Búsqueda semántica',
  match_stage_deep_search: 'Análisis profundo',
  match_stage_rerank: 'Emparejamiento inteligente',
  match_stage_refining: 'Optimizando resultados',
  match_stage_fetch_details: 'Obteniendo detalles',

  // ChannelDetail.vue - Subida de imágenes
  channel_select_image: 'Selecciona un archivo de imagen',
  channel_image_upload_failed: 'Error al subir la imagen, inténtalo de nuevo',
  chatInput_channelSearchHint: "Buscar grupos",
}



// WEBPACK FOOTER //
// ./src/i18n/es.js